import { videoAdsAtom } from "@sunrise/ads";
import { atom } from "jotai";

export const playerShouldDetachAtom = atom((get) => {
  return !!get(videoAdsAtom).adConfig;
});
